// Configuración de la API
const API_BASE_URL = (import.meta as any).env?.VITE_API_URL || 'https://zfdexk1sqh.execute-api.us-east-1.amazonaws.com/production';

export { API_BASE_URL };

// Configuración de axios por defecto
import axios from 'axios';

axios.defaults.baseURL = API_BASE_URL;
axios.defaults.headers.common['Content-Type'] = 'application/json';

// Interceptor para agregar token de autenticación desde Zustand store
axios.interceptors.request.use(
  (config) => {
    const authData = JSON.parse(localStorage.getItem('fuigo-auth') || '{}');
    const token = authData?.state?.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor de respuesta: auto-refresh en 401, logout si falla
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    // No interceptar 401 en endpoints de auth (login, register, etc.)
    const isAuthEndpoint = originalRequest?.url?.includes('/auth/');
    if (error.response?.status === 401 && !originalRequest._retry && !isAuthEndpoint) {
      originalRequest._retry = true;
      try {
        const authData = JSON.parse(localStorage.getItem('fuigo-auth') || '{}');
        const refreshToken = authData?.state?.refreshToken;
        if (refreshToken) {
          const res = await axios.post(`${API_BASE_URL}/auth/refresh`, { refreshToken });
          if (res.data.success && res.data.token) {
            // Actualizar token en store
            authData.state.token = res.data.token;
            localStorage.setItem('fuigo-auth', JSON.stringify(authData));
            originalRequest.headers.Authorization = `Bearer ${res.data.token}`;
            return axios(originalRequest);
          }
        }
      } catch { /* refresh falló */ }
      // Si no se pudo refrescar, limpiar sesión
      localStorage.removeItem('fuigo-auth');
      window.location.href = '/login';
    }
    // Rate limit - mostrar mensaje amigable
    if (error.response?.status === 429) {
      const msg = error.response?.data?.message || 'Demasiadas solicitudes. Intenta en unos minutos.';
      console.warn('Rate limited:', msg);
    }
    return Promise.reject(error);
  }
);

export default axios;
